// biome-ignore lint/style/noRestrictedImports: component usage
import { List } from "@radix-ui/react-tabs";
import React from "react";

import { cx } from "~/tools/class-variance";

import styles from "./_tabs.module.css";

export type TabsListProps = React.ComponentPropsWithoutRef<typeof List>;

export const TabsList = React.forwardRef<React.ElementRef<typeof List>, TabsListProps>(
	({ className, ...props }, ref) => <List className={cx(styles.list, className)} ref={ref} {...props} />,
);

if (import.meta.env.DEV) {
	TabsList.displayName = List.displayName;
}
